module.exports = __webpack_public_path__ + "img/truck.434d3ebc.png";